import translationData from "./translations";
var KEY_SEPARATOR = /\./;

function currentLocale() {
  if (Alchemy.locale == null) {
    throw "Alchemy.locale is not set! Please set Alchemy.locale to a locale string in order to translate something.";
  }

  return Alchemy.locale;
}

function getTranslations() {
  var locale = currentLocale();
  var translations = translationData[locale];

  if (translations) {
    return translations;
  }

  console.warn("Translations for locale ".concat(locale, " not found!"));
  return {};
}

function nestedTranslation(translations, key) {
  var keys = key.split(KEY_SEPARATOR);
  var group = translations[keys[0]];

  if (group) {
    return group[keys[1]] || key;
  }

  return key;
}

function getTranslation(key) {
  var translations = getTranslations();

  if (KEY_SEPARATOR.test(key)) {
    return nestedTranslation(translations, key);
  }

  return translations[key] || key;
}

export default function translate(key, replacement) {
  var translation = getTranslation(key);

  if (replacement) {
    return translation.replace(/%\{.+\}/, replacement);
  }

  return translation;
}